import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueCookie from 'vue-cookie';
import store from '@/store';

import globalFooter from './global-footer';
import deDe from './locale/footer/de-DE.json';
import enUs from './locale/footer/en-US.json';
import esEs from './locale/footer/es-419.json';
import frFr from './locale/footer/fr-FR.json';
import itIt from './locale/footer/it-IT.json';
import nlNL from './locale/footer/nl-NL.json';
import plPl from './locale/footer/pl-PL.json';
import ptBr from './locale/footer/pt-BR.json';
import ruRu from './locale/footer/ru-RU.json';
import thTh from './locale/footer/th-TH.json';
import trTr from './locale/footer/tr-TR.json';
import zhTw from './locale/footer/zh-TW.json';

Vue.use(VueI18n);
Vue.use(VueCookie);

Vue.config.productionTip = false;

// remove dataLayer not define error
window.dataLayer = window.dataLayer || [];

const locale = 'en',
	i18n = new VueI18n({
		silentTranslationWarn: true,
		fallbackLocale: 'en',
		locale,
		messages: {
			de: deDe,
			en: enUs,
			es: esEs,
			fr: frFr,
			it: itIt,
			nl: nlNL,
			pl: plPl,
			pt: ptBr,
			ru: ruRu,
			th: thTh,
			tr: trTr,
			zh: zhTw,
		},
	});

/* eslint-disable no-new */
window.Footer = new Vue({
	el: '#globalFooter',
	i18n,
	store,
	render: (h) => h(globalFooter),
});

// window.environment = process.env.NODE_ENV;
